// src/components/common/Form/SlideExperience.js
import React from "react";

const SlideExperience = ({ data, isActive, onSelect }) => (
  <div className={`carousel-item c-item ${isActive ? "active" : ""}`}>
    <h1 className="display-2 fw-bolder text-capitalize mb-5 hero-title">
      {data.titleBefore} <span className="text-color">{data.titleRed}</span>
      {data.titleAfter}
    </h1>
    <div className="container">
      <div className="row">
        {Object.keys(data.options).map((key) => (
          <div className="col-12 col-md-4 mb-2" key={key}>
            <button type="button" className="custom-btn medium" onClick={() => onSelect(key)}>
              {data.options[key]}
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SlideExperience;
